<div class="bloque-patrocinados-container">
  <h1 class="patrocinadoTitulo">CONTENIDO PATROCINADO</h1>
  <div class="contenedor-noticias">
    <ng-container *ngFor="let noticia of noticias | async; trackBy: trackByNoticia">
      <app-noticia [noticia]="noticia" [idStart]="idStart" [size]="230"></app-noticia>
    </ng-container>
  </div>
</div>
